module.exports = __webpack_public_path__ + "img/logo.1ab49b2b.png";